

//忠诚度管理-互动会员
import { get, post, postJson,put } from '../axios2'

const RESOURCE_BASE_PATH = '/member';


//查询互动会员列表
export const memberList = p => postJson(`${RESOURCE_BASE_PATH}/list` ,p);

//更新
export const member = p => put(`${RESOURCE_BASE_PATH}` ,p);

//获取MemberVO
export const detail = id => get(`${RESOURCE_BASE_PATH}/detail/${id}`);


//积分日志
export const point = p => put(`${RESOURCE_BASE_PATH}/center/point`,p);


//积分变更
export const details = p => postJson(`${RESOURCE_BASE_PATH}/center/point/details`,p);

// 京豆日志列表数据
export const getBeanRecordList = p => get(`${RESOURCE_BASE_PATH}/center/beanRecordList`, p);

// 京豆发放
export const sendBean = p => postJson(`${RESOURCE_BASE_PATH}/center/sendBean`, p);

// 获取京豆计划
export const beanList = p => postJson(`/beansPlan/list`, p)

//分页查询会员生日变更记录
export const getMemberBirthChangeRecord = p => postJson(`/memberBirthChangeRecord/page` ,p);